import ModalWrapper from './ModalWrapper.tsx'
import PropTypes from 'prop-types'
import ShareableLinkAndAccessCode from './partials/ShareableLinkAndAccessCode.jsx'
import UpgradeMessage from '../UpgradeMessage.jsx'
import ToggleButton from '../interactives/ToggleButton.jsx'
import { useCallback, useEffect, useState } from 'react'
import { faUserLock, faUserPen } from '@fortawesome/free-solid-svg-icons'
import { Features } from '~shared/types'
import { generateEventLinkWithSignature } from '../../utils/generateLinkWithSignature.js'

const ACCESS_TYPE_READ = 'READ'
const ACCESS_TYPE_FULL = 'FULL'

export default function EventCollaborateModal({
  eventId,
  plan,
  open,
  setOpen,
}) {
  const [accessType, setAccessType] = useState(ACCESS_TYPE_READ)
  const [loading, setLoading] = useState(false)
  const [url, setUrl] = useState()

  const buildUrl = useCallback(async () => {
    setLoading(true)
    const newUrl = await generateEventLinkWithSignature(
      eventId,
      accessType == ACCESS_TYPE_FULL,
    )
    setUrl(newUrl)
    setLoading(false)
  }, [eventId, accessType])

  useEffect(() => {
    if (open) void buildUrl()
  }, [open, buildUrl])

  return (
    <ModalWrapper
      title="Invite Guests"
      open={[open, setOpen]}
    >
      <p className="text-gray-400 font-light">
        Choose if guests have full access to edit cues, columns and run the show
      </p>

      <ToggleButton
        options={[
          {
            value: ACCESS_TYPE_READ,
            label: 'Only read access',
            icon: faUserLock,
          },
          {
            value: ACCESS_TYPE_FULL,
            label: 'Full read and write access',
            icon: faUserPen,
            disabled: !plan?.features?.includes(Features.GUEST_EDIT),
          },
        ]}
        selected={accessType}
        updateSelected={setAccessType}
      />
      <div className="text-right">
        {!plan?.features?.includes(Features.GUEST_EDIT) && (
          <UpgradeMessage message="Upgrade your account to give write access." />
        )}
      </div>
      <div className="mt-6 space-y-2">
        <p className="text-gray-400 font-light">
          Share with {accessType === ACCESS_TYPE_READ ? 'read' : 'full'} access
        </p>
        <ShareableLinkAndAccessCode
          url={url}
          loading={loading}
        />
      </div>
    </ModalWrapper>
  )
}

EventCollaborateModal.propTypes = {
  eventId: PropTypes.string.isRequired,
  plan: PropTypes.object,
  open: PropTypes.bool,
  setOpen: PropTypes.func.isRequired,
}
